import { FileFormats } from "../../../../../../../components/finalForms/libs/data/fileFormatTypes";
import { FormFieldTypes } from "../../../../../../../components/finalForms/libs/data/formFieldType";
import { validationTypes } from "../../../../../../../components/finalForms/libs/data/ValidationTypes";

const initState = {
  lClientKey: null,
  lContractTypeKey: null,
  lInstallmentTypeID: null,
  PurchaseOrderNumber: "",
  Dterminationdate: new Date(),
  EffectiveDate: new Date(),
  contractlength: null,
  sContractName: null,
};
export const importModelContractConfig = {
  name: "AddContracts",
  initialState: initState,
  section: [
    {
      sectionId: "basicDetailSection",
      title: "Basic Contracts Details",
      row: {},
      style: {
        sectionStyle: "mt-2",
      },
      //   wrapperTemplate: <div className="row"></div>, // Wrapper HTML or Component
      rowGroup: [
        {
          groupLabel: "Contact Information", // Group for contact fields
          style: {
            groupStyle: "mb-1 px-2",
          },
          groupWrapper: <div className="row"></div>, // Wrapper HTML or Component
          fields: [
            {
                    id: "importContractCost",
                    label: "",
                    Field_Name: "file",
                    fieldType: FormFieldTypes.FILE,
                    dataField: "importContractCost",
                    fieldSetting: {
                        placeholder: 'Select Contract Costs',
                        allowMultipleFiles: false,
                        acceptedFileFormats: [
                            FileFormats.XLSX,
                        ],
                        minFileSizeInMB: 0,
                        maxFileSizeInMB: 3,
                    },
                    validation: [
                        // { type: validationTypes.REQUIRE },
                        { type: validationTypes.FILE },
                    ],
                    style: {
                        containerCss: "col-12 mb-1",
                    },
                },
            
           
          ],
        },
      ],
    },
  ],
};
